import WebMatchPrediction from './src/pages/EventSaga/WebMatchPrediction';
import WebMatchPredictionUpdate from './src/pages/EventSaga/WebMatchPrediction/WebMatchPredictionUpdate';
import WebMatchPredictionCreate from './src/pages/EventSaga/WebMatchPrediction/WebMatchPredictionCreate';

const MenuEventSaga = [
    {
        id: 'web-match-prediction',
        name: 'WebMatchPrediction',
        icon: 'icon-chemistry',
        path: 'web-match-prediction',
        component: WebMatchPrediction,
        isShown: 1,
    },
    {
        path: 'web-match-prediction/create',
        name: 'WebMatchPrediction > Create',
        component: WebMatchPredictionCreate,
        isShown: 0,
    },
    {
        path: 'web-match-prediction/update/:id',
        name: 'WebMatchPrediction > Update',
        component: WebMatchPredictionUpdate,
        isShown: 0,
    },
];

export default MenuEventSaga;
